/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';

interface Props {
  isActive?: boolean;
  isEmbedded?: boolean;
  className?: string;
}

export default React.memo(({ isActive, isEmbedded, className = '' }: Props) => {
  if (isEmbedded) {
    return <span className={`spinner${!isActive ? ' disabled' : ''} ${className}`} />;
  }

  if (!isActive) {
    return null;
  }
  return (
    <div className="spinner-container">
      <span className={`spinner ${className}`} />
    </div>
  );
});
